<script>
  import Notebook from "../../assets/svgs/help-folder.svg";
  export let width = "30vw";
</script>

<span>
  <Notebook width="{width}" />
</span>
